import localFetch from "@/modules/instances/localFetch";

/**
 * Local/self-hosted mode: creates a real API key via the local backend
 * (POST /v1/auth/api-keys). See getApiKeys.ts for why this replaces the
 * upstream OSS stub.
 */
export interface CreatedApiKey {
  id: string;
  key: string;
}

export default async function createApiKey(
  options: { name?: string; noRedirectOnAuth?: boolean } = {},
): Promise<CreatedApiKey> {
  const response = await localFetch("/v1/auth/api-keys", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name: options.name || `key-${Date.now()}` }),
  });
  const data = await response.json();
  return { id: data.id, key: data.key };
}
